    <div class="rental-edit">
      <div class="page-header">
        <button mat-icon-button (click)="goBack()" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Редактирование проката #{{ rentalId }}</h1>
      </div>

      <!--
        Спиннер показывается поверх формы, а не вместо неё. Это критично:
        при `*ngIf="!loading"` Angular создаёт DOM-инпут только после
        получения ответа, и `formControl.setValue` срабатывает в той же
        синхронной фазе, что и отрисовка `<input>`. Для
        `<input type="datetime-local">` это приводит к ситуации, когда
        `formControl.value` корректен, а визуально поле пустое.
        Рендерим форму всегда, а `loading` показываем как оверлей.
      -->
      <div class="form-wrapper">
        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="rental-form" [class.is-loading]="loading">
          <mat-card class="form-card">
            <mat-card-content>
              <h3 class="section-title">Выдача</h3>

              <app-datetime-input
                formControlName="handoverDate"
                dateLabel="Дата выдачи"
                timeLabel="Время"
                [required]="true">
              </app-datetime-input>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Место выдачи</mat-label>
                <input matInput formControlName="handoverLocation" required>
                <mat-error *ngIf="form.get('handoverLocation')?.hasError('required')">Укажите место выдачи</mat-error>
                <mat-error *ngIf="form.get('handoverLocation')?.hasError('serverError')">{{form.get('handoverLocation')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Пробег при выдаче, км</mat-label>
                <input matInput formControlName="mileageBefore" type="number" required>
                <mat-error *ngIf="form.get('mileageBefore')?.hasError('required')">Укажите пробег</mat-error>
                <mat-error *ngIf="form.get('mileageBefore')?.hasError('min')">Значение должно быть не меньше 0</mat-error>
                <mat-error *ngIf="form.get('mileageBefore')?.hasError('serverError')">{{form.get('mileageBefore')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Уровень топлива при выдаче, км</mat-label>
                <input matInput formControlName="fuelLevelBefore" type="number">
                <mat-error *ngIf="form.get('fuelLevelBefore')?.hasError('min')">Значение должно быть не меньше 0</mat-error>
                <mat-error *ngIf="form.get('fuelLevelBefore')?.hasError('serverError')">{{form.get('fuelLevelBefore')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <app-image-upload
                formControlName="imagesBefore"
                label="Фото до проката"
                emptyHint="Фото не добавлены">
              </app-image-upload>

              <mat-divider class="section-divider"></mat-divider>

              <h3 class="section-title">Возврат</h3>

              <app-datetime-input
                formControlName="returnDate"
                dateLabel="Дата возврата"
                timeLabel="Время">
              </app-datetime-input>

              <app-datetime-input
                formControlName="expectedReturnDate"
                dateLabel="Ожидаемая дата возврата"
                timeLabel="Время">
              </app-datetime-input>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Место возврата</mat-label>
                <input matInput formControlName="returnLocation">
                <mat-error *ngIf="form.get('returnLocation')?.hasError('serverError')">{{form.get('returnLocation')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Пробег при возврате, км</mat-label>
                <input matInput formControlName="mileageAfter" type="number">
                <mat-error *ngIf="form.get('mileageAfter')?.hasError('min')">Значение должно быть не меньше 0</mat-error>
                <mat-error *ngIf="form.get('mileageAfter')?.hasError('serverError')">{{form.get('mileageAfter')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Уровень топлива при возврате, км</mat-label>
                <input matInput formControlName="fuelLevelAfter" type="number">
                <mat-error *ngIf="form.get('fuelLevelAfter')?.hasError('min')">Значение должно быть не меньше 0</mat-error>
                <mat-error *ngIf="form.get('fuelLevelAfter')?.hasError('serverError')">{{form.get('fuelLevelAfter')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <app-image-upload
                formControlName="imagesAfter"
                label="Фото после проката"
                emptyHint="Фото не добавлены">
              </app-image-upload>

              <mat-divider class="section-divider"></mat-divider>

              <h3 class="section-title">Дополнительно</h3>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Маршрут</mat-label>
                <input matInput formControlName="route" maxlength="255" placeholder="Например: Сочи — Красная Поляна — Роза Хутор">
                <mat-icon matSuffix>route</mat-icon>
                <mat-error *ngIf="form.get('route')?.hasError('maxlength')">Максимум 255 символов</mat-error>
                <mat-error *ngIf="form.get('route')?.hasError('serverError')">{{form.get('route')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Заметки</mat-label>
                <textarea matInput formControlName="notes" rows="3"></textarea>
                <mat-error *ngIf="form.get('notes')?.hasError('serverError')">{{form.get('notes')?.getError('serverError')}}</mat-error>
              </mat-form-field>

              <mat-divider class="section-divider"></mat-divider>

              <h3 class="section-title">Дополнительные услуги</h3>
              <p *ngIf="extraServices.length === 0" class="empty-hint">Список услуг пуст. Можно сохранить прокат без доп. услуг.</p>
              <div formArrayName="extraServices" *ngIf="extraServices.length > 0">
                <div *ngFor="let esGroup of extraServicesForm.controls; let i = index" [formGroupName]="i" class="extra-service-row">
                  <mat-checkbox formControlName="selected" class="extra-service-checkbox">
                    {{ extraServices[i].name }}
                  </mat-checkbox>
                  <mat-form-field appearance="outline" class="extra-service-amount">
                    <mat-label>Сумма, ₽</mat-label>
                    <input matInput type="number" formControlName="amount" min="0.01" step="0.01" inputmode="decimal" placeholder="0.00">
                    <mat-icon matSuffix>payments</mat-icon>
                    <mat-error *ngIf="esGroup.get('amount')?.hasError('min')">Сумма должна быть больше 0</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <button mat-raised-button color="primary" type="submit" class="full-width-btn"
                  [disabled]="form.invalid || submitting || loading">
            <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
            <span *ngIf="!submitting"><mat-icon>save</mat-icon> Сохранить</span>
          </button>
        </form>

        <div *ngIf="loading" class="loading-overlay" aria-hidden="true">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </div>
    </div>
